import React, { Component } from 'react';
import './styles.css';

export default class LatestResultsWidget extends Component {
  render() {
    return (
      <div className="results__widget">
        LatestResultsWidget
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/LatestResultsWidget/LatestResultsWidget.js